export const LOADING_ADMIN_DOCUMENT_LIST = "LOADING_ADMIN_DOCUMENT_LIST";
export const SUCCESS_ADMIN_DOCUMENT_LIST = "SUCCESS_ADMIN_DOCUMENT_LIST";
